import { apiRequest } from './queryClient';

/**
 * Sign the user out on the server.
 *
 * Routed through apiRequest (NOT a raw fetch) so the CSRF token is attached and a
 * stale-token 403 is retried. POST /api/auth/logout is CSRF-protected on the server;
 * a request without the token is rejected 403, which leaves the server session alive
 * and silently "signs the user back in" after a refresh.
 */
export async function postLogout(): Promise<void> {
  await apiRequest('POST', '/api/auth/logout');
}
